<script setup>
import Breadcrumb from "@/components/navigate/Breadcrumb.vue";

</script>

<template>
  <div class="d-flex  bg-light justify-content-between align-items-center flex-wrap mb-4 p-3 rounded-3">
    <Breadcrumb/>
    <div class="d-flex align-items-center mt-2 mt-md-0 gap-3">

      <!-- Поиск -->
<!--      <form class="d-flex" role="search">-->
<!--        <input class="form-control" type="search" placeholder="Пошук..." aria-label="Search">-->
<!--      </form>-->

      <!-- Иконка уведомлений -->
      <div class="position-relative">
        <i class="bi bi-bell fs-4"></i>
        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
        3
        <span class="visually-hidden">нові сповіщення</span>
      </span>
      </div>

    </div>
  </div>
</template>

<style scoped lang="scss">

</style>